/**
 * Must stay aligned with backend `utils/schoolAccess.util.js` → CODES.
 * Used by api.service and any UI that branches on school suspension / read-only.
 */
export const SCHOOL_PORTAL_ERROR_CODES = Object.freeze({
  SCHOOL_BLOCKED: 'SCHOOL_BLOCKED',
  SCHOOL_INACTIVE: 'SCHOOL_INACTIVE',
  SCHOOL_NOT_FOUND: 'SCHOOL_NOT_FOUND',
});

export const SCHOOL_PORTAL_EVENT = Object.freeze({
  API_FORBIDDEN: 'uniqcamp:api-forbidden',
});

export const SCHOOL_PORTAL_SESSION_KEYS = Object.freeze({
  LOGIN_NOTICE: 'uniqcampLoginNotice',
});
